import { Link } from "react-router-dom";
import { m } from "framer-motion";
import { ArrowRight, Phone } from "lucide-react";
import { useQuoteForm } from "@/components/QuoteFormContext";
import { Button } from "@/components/ui/button";
import LocationMap from "@/components/LocationMap";
import { siteConfig } from "@/lib/site-config";

const ServiceAreas = () => {
  const { openQuoteForm } = useQuoteForm();

  return (
    <section id="locations" className="section-padding bg-background">
      <div className="container-max">
        <div className="text-center mb-14 md:mb-16">
          <m.span
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="inline-block text-primary text-sm font-bold uppercase tracking-widest mb-3"
          >
            Coverage
          </m.span>
          <m.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="font-heading text-4xl md:text-5xl lg:text-6xl text-foreground mb-4 tracking-tight font-bold"
          >
            Areas We <span className="text-gradient-primary">Serve</span>
          </m.h2>
          <m.p
            initial={{ opacity: 0, y: 15 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-muted-foreground max-w-2xl mx-auto text-lg"
          >
            Based in {siteConfig.address.city}, {siteConfig.address.state} — serving a{" "}
            {siteConfig.address.serviceRadius} radius across Marshall, St. Joseph, Elkhart, LaPorte,
            Porter, and Lake counties in Indiana, plus Berrien and St. Joseph counties in Michigan.
          </m.p>
        </div>

        <m.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-6xl mx-auto"
        >
          <LocationMap />
        </m.div>

        <m.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-10 md:mt-12"
        >
          <Button size="lg" onClick={openQuoteForm} className="gap-2 px-7 rounded-xl font-semibold">
            Get Free Estimate
          </Button>
          <Link to="/locations">
            <Button variant="outline" size="lg" className="gap-2 px-7 rounded-xl font-semibold">
              View All Areas <ArrowRight className="h-5 w-5" />
            </Button>
          </Link>
          <a href={siteConfig.phoneHref}>
            <Button variant="secondary" size="lg" className="gap-2 px-7 rounded-xl font-semibold">
              <Phone className="h-4 w-4" /> {siteConfig.phone}
            </Button>
          </a>
        </m.div>
      </div>
    </section>
  );
};

export default ServiceAreas;
